import { render, staticRenderFns } from "./gudinzc.vue?vue&type=template&id=678fa260&scoped=true&"
import script from "./gudinzc.vue?vue&type=script&lang=js&"
export * from "./gudinzc.vue?vue&type=script&lang=js&"
import style0 from "./gudinzc.vue?vue&type=style&index=0&id=678fa260&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fa260",
  null
  
)

export default component.exports